import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';

import {
  setFeatureFlagsAction,
  getFeatureFlagsAction,
} from './feature-flags.actions';

export type FeatureFlagsState = {
  [featureFlagId: string]: boolean;
};

const initialState: FeatureFlagsState = {};

const _reducer = createReducer(
  initialState,
  on(setFeatureFlagsAction, (state, { featureFlagId, isEnabled }) => ({
    ...state,
    [featureFlagId]: isEnabled,
  })),
  on(getFeatureFlagsAction, (state) => ({
    ...state,
  }))
);

export function featureFlagsReducer(
  state: FeatureFlagsState = initialState,
  action: Action
): FeatureFlagsState {
  return _reducer(state, action);
}
